import { employeeConstants } from "../../constants";

export function deleteEmployeeReducer(state = {}, action) {
  switch (action.type) {
    case employeeConstants.DELETE_EMPLOYEE_REQUEST:
      return { loading: true };
    case employeeConstants.DELETE_EMPLOYEE_SUCCESS:
      return { employee: action.payload.data };
    case employeeConstants.DELETE_EMPLOYEE_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
